var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('mc-app-header',{attrs:{"title":"Home"}}),_c('mc-app-body',[_c('div',{staticClass:"section"},[_c('p',{staticClass:"content is-large"},[_vm._v("\n        Welcome! This is MadamCurious Admin!\n      ")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }